import styled from "styled-components";


function ProductionCard({content: {label, titleBold, titleLight, image }}) {
    return (
        <ProductionCardSC>

            {/* Left Text */}
            <div className="textBlock">
                <div className="label">{label}</div>

                <div className="title bold">
                    {titleBold}
                </div>
                <div className="title light">
                    {titleLight}
                </div>
            </div>

            {/* Right Artwork */}
            <div className="artwork">
                <img src={image}/>
            </div>

        </ProductionCardSC>
    );
}

const ProductionCardSC = styled.div`
    width: 160px;
    height: 240px;
    background: #ffffff;
    font-family: Inter, system-ui, sans-serif;
    box-sizing: border-box;
    overflow: hidden;
    padding: 16px;

    .title {
        font-size: 18px;
        line-height: 1.3;
        max-width: 100%;
        word-break: break-word;

        &.bold {
            color: #000000EE;
            font-weight: 600;
        }

        &.light {
            color: #000000CC;
            font-weight: 400;
            margin-top: 2px;
        }
    }

    .textBlock {
          max-width: 100%;
    }

    .label {
        font-size: 12px;
        letter-spacing: 0.12em;
        color: #888;
        font-weight: 600;
        margin-bottom: 18px;
    }

    .artwork {
        position: absolute;
        bottom: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-left: -16px;
        img {
            width: 56px;
            height: 56px;
        }
    }
`;


export default ProductionCard;